import React from 'react';
import { Tr, Td, Badge, Text, Button } from '@chakra-ui/react';
import tinycolor from 'tinycolor2';
import { ChevronRightIcon } from '@chakra-ui/icons';
import { log } from '../../utils';
// import { Link } from 'react-router-dom';

interface CustomTableRowProps<T> {
  rowBorderColor?: string;
  fields: string[];
  item: T;
  fieldsAsLinks?: string[];
  rowHoverBgColor: string;
  tableRowTextColor: string;
  secondaryAccentColor?: string;
  tertiaryAccentColor?: string;
  onTicketClick: () => void;
  showArrow?: boolean;
  isPreview?: boolean;
  ticketHref?: string;
  ticketData?: any;
}
export const CustomTableRow = <T,>({
  rowBorderColor,
  fields,
  item,
  fieldsAsLinks = [],
  rowHoverBgColor,
  tableRowTextColor,
  onTicketClick,
  secondaryAccentColor,
  tertiaryAccentColor,
  showArrow = false,
  isPreview,
  ticketHref,
  ticketData,
}: CustomTableRowProps<T>) => {
  log(false, `${ticketHref},${ticketData}`);
  // const handleTicketClick = (e: React.MouseEvent) => {
  const handleTicketClick = () => {
    // if (isPreview) {
    //   onTicketClick();
    //   return;
    // }
    // const isLeftClick = e.button === 0;
    // const isModifiedClick = e.metaKey || e.ctrlKey || e.shiftKey || e.altKey;

    // if (isLeftClick && !isModifiedClick) {
    //   e.preventDefault();
    //   onTicketClick();
    // }
    onTicketClick();
  };

  const rowContent = (
    <Tr
      borderBottom={`2px solid ${rowBorderColor}`}
      _hover={{ bg: rowHoverBgColor, cursor: 'pointer' }}
      onClick={handleTicketClick}
    >
      {fields.map(field => {
        const value = item[field as keyof T];

        // Status column styling
        if (field.toLowerCase() === 'status' && typeof value === 'string') {
          return (
            <Td key={field} padding="0.5rem" height="2rem" textAlign="center">
              <Badge
                bg={tinycolor(tertiaryAccentColor).darken(5).toString()}
                px="3"
                py="1.5"
                borderRadius="full"
                textTransform="none"
                fontWeight="medium"
                fontSize="sm"
                border="1px solid"
                borderColor="gray.400"
              >
                {value}
              </Badge>
            </Td>
          );
        }

        if (field === 'Ticket #' && typeof value === 'number') {
          return (
            <Td key={field} padding="0.8rem" height="2rem">
              {fieldsAsLinks.includes(field) ? (
                <Button
                  variant="link"
                  color={secondaryAccentColor}
                  fontWeight="semibold"
                  padding="0"
                  minWidth="auto"
                  onClick={handleTicketClick}
                >
                  {value}
                </Button>
              ) : (
                <Text fontWeight="semibold">{value}</Text>
              )}
            </Td>
          );
        }

        return (
          <Td key={field} padding="0.8rem" height="2rem" color={tableRowTextColor}>
            {fieldsAsLinks.includes(field) ? (
              <Button
                onClick={handleTicketClick}
                variant="link"
                color="#3D80CC"
                fontWeight="semibold"
                padding="0"
                minWidth="auto"
              >
                {String(value ?? '')}
              </Button>
            ) : (
              String(value ?? '')
            )}
          </Td>
        );
      })}

      {/* ➡️ Arrow icon cell (optional) */}
      {showArrow && (
        <Td padding="0.8rem" height="2rem" textAlign="right" color={secondaryAccentColor}>
          <ChevronRightIcon boxSize={5} />
        </Td>
      )}
    </Tr>
  );
  if (!isPreview) {
    return (
      // <Link
      //   to={ticketHref || '#'}
      //   state={{ ticketData }}
      //   style={{ display: 'contents', textDecoration: 'none' }}
      // >
      // { rowContent }
      rowContent
      // </Link>
    );
  }

  // otherwise normal spa click behavior
  return rowContent;
};
